/** @format */

import React from 'react';
import { memo } from 'react';
import { TRoom } from '@/ducks/room/declarations';
import { RoomInformations, RoomInfoTitle } from '../index.style';
import RoomInfoPosition from './RoomInfoPosition';

const RoomHeader = memo(({ title, room }: { title: string; room: TRoom }) => (
  <RoomInformations>
    <RoomInfoTitle>{title}</RoomInfoTitle>
    <RoomInfoPosition room={room} />
  </RoomInformations>
));

export default RoomHeader;
